(function () {
  'use strict';

  document.querySelectorAll('[data-jrj-v56-oem-finder]').forEach(function (form) {
    var result = form.parentElement.querySelector('[data-jrj-v56-oem-result]');
    var routes = {
      '99-06': { chevrolet: { silverado: '/collections/99-06-gm' }, gmc: { sierra: '/collections/99-06-gm' } },
      '07-13': { chevrolet: { silverado: '/collections/07-13-gm' }, gmc: { sierra: '/collections/07-13-gm' } },
      '14-18': { chevrolet: { silverado: '/collections/14-18-gm' }, gmc: { sierra: '/collections/14-18-gm' } }
    };

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var year = form.elements.year_range.value;
      var make = form.elements.make.value;
      var model = form.elements.model.value;
      var route = routes[year] && routes[year][make] && routes[year][make][model];

      if (route) {
        window.location.assign(route);
        return;
      }

      if (result) {
        result.textContent = 'Choose a matching year range, make, and truck model. If your vehicle is not listed, text Jason at 910-239-7598 before ordering.';
        result.focus();
      }
    });
  });
})();
